import { createSelector } from 'reselect';
import { AppState } from '../reducers/root.reducer';

const state = (state: AppState) => state.survey.report;

const getList = createSelector(state, (state) => state.list);
const getDetailLoading = createSelector(state, (state) => state.detail.loading);

const OutputReportSelectors = {
    getList,
    getDetailLoading,
};

export default OutputReportSelectors;
